import React from 'react'

const NoResultsIcon = () => {
  return (
    <svg
      fill="none"
      height="131"
      viewBox="0 0 120 131"
      width="120"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M61.7712 89.047C86.5247 89.047 106.591 69.1132 106.591 44.5235C106.591 19.9339 86.5247 0 61.7712 0C37.0178 0 16.9512 19.9339 16.9512 44.5235C16.9512 69.1132 37.0178 89.047 61.7712 89.047Z"
          fill="#F5F5F7"
        />
        <path
          d="M61.7733 81.2796C82.2083 81.2796 98.7741 64.8234 98.7741 44.5236C98.7741 24.2238 82.2083 7.76758 61.7733 7.76758C41.3383 7.76758 24.7725 24.2238 24.7725 44.5236C24.7725 64.8234 41.3383 81.2796 61.7733 81.2796Z"
          fill="black"
          opacity="0.05"
        />
        <path
          d="M61.7711 74.6488C78.5191 74.6488 92.096 61.1617 92.096 44.5246C92.096 27.8875 78.5191 14.4004 61.7711 14.4004C45.0232 14.4004 31.4463 27.8875 31.4463 44.5246C31.4463 61.1617 45.0232 74.6488 61.7711 74.6488Z"
          fill="black"
          opacity="0.05"
        />
        <path
          d="M61.7711 66.1217C73.7794 66.1217 83.514 56.4516 83.514 44.5228C83.514 32.594 73.7794 22.9238 61.7711 22.9238C49.7629 22.9238 40.0283 32.594 40.0283 44.5228C40.0283 56.4516 49.7629 66.1217 61.7711 66.1217Z"
          fill="black"
          opacity="0.05"
        />
        <path
          d="M79.8039 58.1113L95.3114 73.6007C95.7791 74.1527 96.0206 74.8604 95.9877 75.5823C95.9547 76.3041 95.6496 76.987 95.1335 77.4943C94.6173 78.0016 93.9282 78.296 93.2037 78.3187C92.4793 78.3413 91.773 78.0906 91.226 77.6165L75.7472 62.1844C71.1229 65.7659 65.3032 67.4554 59.4733 66.9091C53.6433 66.3628 48.2414 63.6217 44.3674 59.244C40.4934 54.8662 38.4387 49.1809 38.6216 43.3458C38.8045 37.5107 41.2112 31.9644 45.3518 27.8363C49.4924 23.7083 55.0554 21.3088 60.9082 21.1264C66.761 20.9441 72.4635 22.9926 76.8545 26.8549C81.2455 30.7172 83.9949 36.1028 84.5429 41.9152C85.0908 47.7275 83.3962 53.5296 79.8039 58.14V58.1113ZM61.6207 61.2665C66.199 61.2665 70.5898 59.4533 73.8271 56.2257C77.0645 52.9981 78.8832 48.6206 78.8832 44.0561C78.8832 39.4916 77.0645 35.114 73.8271 31.8864C70.5898 28.6589 66.199 26.8456 61.6207 26.8456C57.0423 26.8456 52.6515 28.6589 49.4142 31.8864C46.1768 35.114 44.3581 39.4916 44.3581 44.0561C44.3581 48.6206 46.1768 52.9981 49.4142 56.2257C52.6515 59.4533 57.0423 61.2665 61.6207 61.2665Z"
          fill="white"
        />
        <path
          d="M21.1266 57.8652C21.1266 57.8652 17.6031 67.718 19.1685 71.2153C20.3027 73.624 21.657 75.9241 23.2144 78.0869C23.2144 78.0869 22.3011 58.5139 21.1266 57.8652Z"
          fill="#D0CDE1"
        />
        <path
          d="M21.1266 57.8633C21.1266 57.8633 17.6031 67.716 19.1685 71.2134C20.3027 73.622 21.657 75.9222 23.2144 78.0849C23.2144 78.0849 22.3011 58.512 21.1266 57.8633Z"
          fill="black"
          opacity="0.1"
        />
        <path
          d="M23.6053 80.6833C23.5292 81.5549 23.3983 82.4209 23.2135 83.2762C23.0829 83.406 23.3441 83.6654 23.2135 84.0537C23.0829 84.442 22.9523 84.961 23.2135 85.0879C23.4747 85.2148 21.7778 96.6263 21.7778 96.6263C21.7778 96.6263 17.6013 102.072 19.2982 110.628L19.8206 119.314C19.8206 119.314 23.8665 119.573 23.8665 118.147C23.7364 117.331 23.6492 116.509 23.6053 115.684C23.6053 114.907 24.2574 114.907 23.8665 114.517C23.4756 114.128 23.4747 113.87 23.4747 113.87C23.4747 113.87 24.1268 113.351 23.9971 113.221C23.8675 113.091 25.1716 103.886 25.1716 103.886C25.1716 103.886 26.6073 102.46 26.6073 101.682V100.905C26.6073 100.905 27.2594 99.2192 27.2594 99.0895C27.2594 98.9597 30.7829 91.0512 30.7829 91.0512L32.2186 96.756L33.7849 104.924C33.7849 104.924 34.5675 112.314 36.1338 115.166C36.1338 115.166 38.8785 124.501 38.8785 124.241C38.8785 123.982 43.4458 123.334 43.3162 122.167C43.1865 121.001 40.5716 104.665 40.5716 104.665L41.2265 80.4238L23.6053 80.6833Z"
          fill="#040066"
        />
        <path
          d="M20.0825 118.67C20.0825 118.67 16.5591 125.542 18.9081 125.801C21.257 126.061 22.1713 126.061 23.2152 125.024C24.0388 124.308 24.9286 123.672 25.8727 123.123C26.4247 122.789 26.8705 122.306 27.1592 121.732C27.4478 121.157 27.5674 120.514 27.5043 119.875C27.4352 119.24 27.1967 118.717 26.6099 118.669C25.3714 118.423 24.2088 117.89 23.2171 117.113L20.0825 118.67Z"
          fill="#2F2E41"
        />
        <path
          d="M39.5279 123.725C39.5279 123.725 36.0044 130.596 38.3534 130.856C40.7024 131.115 41.6166 131.115 42.6605 130.078C43.4841 129.363 44.3739 128.727 45.318 128.177C45.8695 127.843 46.315 127.362 46.6034 126.787C46.8918 126.213 47.0115 125.57 46.9487 124.931C46.8796 124.297 46.6411 123.774 46.0543 123.726C44.8158 123.48 43.6532 122.947 42.6614 122.17L39.5279 123.725Z"
          fill="#2F2E41"
        />
        <path
          d="M35.8047 46.6208C38.8347 46.6208 41.291 44.1807 41.291 41.1707C41.291 38.1608 38.8347 35.7207 35.8047 35.7207C32.7747 35.7207 30.3184 38.1608 30.3184 41.1707C30.3184 44.1807 32.7747 46.6208 35.8047 46.6208Z"
          fill="#FFB8B8"
        />
        <path
          d="M32.2782 42.9609C32.2782 42.9609 28.3591 50.1239 28.0458 50.1239C27.7326 50.1239 35.0994 52.4592 35.0994 52.4592C35.0994 52.4592 37.137 45.6084 37.4503 44.9851L32.2782 42.9609Z"
          fill="#FFB8B8"
        />
        <path
          d="M38.2898 50.7982C38.2898 50.7982 30.4592 46.5196 29.6775 46.6494C28.8958 46.7791 20.5418 54.0389 20.6724 57.0211C20.8978 59.679 21.2901 62.3203 21.8469 64.9296C21.8469 64.9296 22.2387 78.6717 23.0214 78.8015C23.8041 78.9312 22.8908 81.2647 23.152 81.2647C23.4132 81.2647 41.4234 81.2647 41.554 80.8754C41.6846 80.4862 38.2898 50.7982 38.2898 50.7982Z"
          fill="#D0CDE1"
        />
        <path
          d="M42.661 81.5898C42.661 81.5898 45.1406 89.111 43.0528 88.8497C40.965 88.5883 40.0508 82.3673 40.0508 82.3673L42.661 81.5898Z"
          fill="#FFB8B8"
        />
        <path
          d="M36.0054 50.3453C36.0054 50.3453 31.1787 51.3794 31.9595 57.8664C32.7403 64.3534 34.1779 70.8311 34.1779 70.8311L39.0046 81.3325L39.527 83.2777L43.0504 82.3704L40.4403 67.3281C40.4403 67.3281 39.527 51.2515 38.3525 50.7335C37.6124 50.4204 36.8077 50.2873 36.0054 50.3453Z"
          fill="#D0CDE1"
        />
        <path
          d="M33.0674 70.638L39.0704 81.2691L34.0138 70.0645L33.0674 70.638Z"
          fill="black"
          opacity="0.1"
        />
        <path
          d="M41.2688 39.5649L41.2867 39.1485L42.1205 39.3544C42.1116 39.2206 42.0735 39.0904 42.009 38.9728C41.9445 38.8551 41.855 38.7527 41.7467 38.6728L42.6354 38.6239C41.8899 37.5716 40.9375 36.6804 39.8356 36.004C38.7337 35.3276 37.5052 34.88 36.2244 34.6884C35.2692 34.5019 34.2831 34.5443 33.3477 34.8122C32.4123 35.08 31.5547 35.5655 30.846 36.2284C30.2296 36.9402 29.7774 37.7774 29.521 38.6812C28.9948 40.3227 28.8878 42.2801 29.9847 43.6151C31.0996 44.9717 33.0473 45.2369 34.802 45.4014C35.4153 45.5101 36.0461 45.4675 36.6389 45.2773C36.7026 44.6253 36.6185 43.9674 36.3929 43.3519C36.299 43.1614 36.2541 42.9508 36.2623 42.7389C36.3399 42.2199 37.0364 42.0892 37.5598 42.1598C38.0832 42.2303 38.7116 42.3374 39.0551 41.9388C39.2451 41.6283 39.334 41.2672 39.3097 40.9047C39.3901 39.9316 41.2565 39.7708 41.2688 39.5649Z"
          fill="#2F2E41"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect fill="white" height="131" width="120" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default NoResultsIcon
